import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Link from '@mui/material/Link';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import SettingsIcon from '@mui/icons-material/Settings';
import HistoryIcon from '@mui/icons-material/History';
import LogoutIcon from '@mui/icons-material/Logout';

import pngLogo02 from "../../assets/imgs/logo02.png";
import imgUser from "../../assets/imgs/user.svg";

import MyImage from "../myImage";
import MyButton from "../myButton";
import SelectLanguage from '../selectLanguage';
import { AuthContext } from "../../contexts/auth";

import { style } from "./styles";

const MyHeader = ({ userState }) => {
    const navigate = useNavigate();
    const { signOut } = useContext(AuthContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleProfileClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSettings = () => {
        handleClose();
        navigate("/user");
    };

    const handleArchive = () => {
        handleClose();
        navigate("/historic");
    };

    const handleLogout = () => {
        handleClose();
        signOut();
    };

    const pricingHandler = () => {
        navigate("/pricing");
    };
    const creditsHandler = () => {
        navigate("/credits");
    };

    return (
        <AppBar sx={style.stack}>
            <Box sx={style.content}>
                <Box sx={style.logoArea}>
                    <Link onClick={() => navigate("/dashboard")} underline="none" sx={style.logoArea}>
                        <MyImage src={pngLogo02} alt={'Admind logo'} sx={style.logo} />
                    </Link>
                </Box>

                <Box sx={style.areaLeft}>
                    <Box sx={style.areaButtons}>
                        <>
                            <MyButton onClick={pricingHandler} text={userState?.subscription?.value?.includes('PRO') ? `Upgrade` : "Try AdMind PRO"} variant="contained" md={style.upgradeButton} sx={style.upgradeButton} />
                            <MyButton onClick={creditsHandler} text="Get More Images" variant="contained" md={style.imageButton} sx={style.imageButton} />
                        </>
                    </Box>
                    <Box>
                        <SelectLanguage />
                    </Box>
                    <Box 
                        onClick={handleProfileClick}
                        sx={{ ...style.iconArea, cursor: 'pointer' }}
                        data-testid="button-profile-menu"
                    >
                        <MyImage src={imgUser} alt={'user icon'} sx={style.icon} />
                    </Box>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                            elevation: 3,
                            sx: {
                                borderRadius: '12px',
                                minWidth: 180,
                                mt: 1.5,
                                '& .MuiMenuItem-root': {
                                    borderRadius: '8px',
                                    mx: 1,
                                    my: 0.5,
                                },
                            },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        <MenuItem onClick={handleSettings} data-testid="menu-item-settings">
                            <ListItemIcon>
                                <SettingsIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Settings</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleArchive} data-testid="menu-item-archive">
                            <ListItemIcon>
                                <HistoryIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Archive</ListItemText>
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={handleLogout} data-testid="menu-item-logout">
                            <ListItemIcon>
                                <LogoutIcon fontSize="small" sx={{ color: '#d32f2f' }} />
                            </ListItemIcon>
                            <ListItemText sx={{ color: '#d32f2f' }}>Logout</ListItemText>
                        </MenuItem>
                    </Menu>
                </Box>
            </Box>
        </AppBar>
    );
};

export default MyHeader;
